module.exports = __WEBPACK_EXTERNAL_MODULE_30__;


//////////////////
// WEBPACK FOOTER
// external "axios"
// module id = 30
// module chunks = 0